/**
 * API configuration - base URLs and endpoint routes
 * Base URL: /v1
 * All API routes in one place for easy maintenance
 */

const appUrl = "https://backend.demoexchange.wrathcode.com"  
// const appUrl = "http://localhost:5001";

export const imageUrl = "https://backend.demoexchange.wrathcode.com";

export const ApiConfig = {
  // ========= Base URLs =========
  baseUrl: `${appUrl}/`,
  imageUrl,
  baseAdmin: `${appUrl}/v1/admin/`,
  baseAdminAuth: `${appUrl}/v1/admin/auth/`,

  // ========= Admin Auth Endpoints =========
  authStep1: "step1",
  authStep2: "step2",
  authResendOtp: "resend-otp",

  // ========= Admin Logs =========
  adminLogs: "logs",

  // ========= Dashboard =========
  dashboardCounts: "dashboard/counts",

  // ========= Enquiries (Contact Form) =========
  contactFormList: "contact-form/list",
  contactFormSetStatus: "contact-form/set-status",

  // ========= Users =========
  adminUsers: "users",
  userDetail: (id) => `users/${id}`,
  userStatus: "users/status",
  userKyc: (id) => `users/${id}/kyc`,
  kycList: "kyc",
  // KYC (centralized routes - body includes userId)
  kycApprove: "kyc/approve",
  kycReject: "kyc/reject",
  kycApproveDocument: "kyc/approve-document",
  kycRejectDocument: "kyc/reject-document",
  userWallets: (id) => `users/${id}/wallets`,
  userTransactions: (id) => `users/${id}/transactions`,
  userInternalTransfers: (id) => `users/${id}/internal-transfers`,
  userSpotTrades: (id) => `users/${id}/spot-trades`,
  userSpotOrders: (id) => `users/${id}/spot-orders`,
  userSwapHistory: (id) => `users/${id}/swap-history`,
  userEarningPlans: (id) => `users/${id}/earning-plans`,
  userLaunchpad: (id) => `users/${id}/launchpad`,
  userSupportTickets: (id) => `users/${id}/support-tickets`,
  userReferral: (id) => `users/${id}/referral`,
  userP2pOrders: (id) => `users/${id}/p2p-orders`,
  userP2pAds: (id) => `users/${id}/p2p-ads`,
  userP2pPaymentMethods: (id) => `users/${id}/p2p-payment-methods`,
  userFuturesTrades: (id) => `users/${id}/futures-trades`,
  userFuturesOrders: (id) => `users/${id}/futures-orders`,
  userFuturesPositions: (id) => `users/${id}/futures-positions`,

  // ========= Coins =========
  coinsConfig: "coins/config",
  coinsList: "coins/list",
  coinsCreate: "coins",
  coinsUpdate: (coinId) => `coins/${coinId}`,

  // ========= Platform =========
  platformConfig: "platform",
  platformCancelSchedule: (feature) => `platform/${feature}/schedule`,

  // ========= Pairs =========
  pairInfo: "pairs/pair-info",
  pairsCreate: "pairs",
  pairsList: "pairs",
  pairStatus: (pairId) => `pairs/${pairId}/status`,

  // ========= Launchpad =========
  launchpadCurrencies: "launchpad/currencies",
  launchpadCreate: "create-launchpad",
  launchpadListing: "launchpad-listing",
  launchpadDetail: (id) => `launchpad/${id}`,
  launchpadUpdate: (id) => `launchpad/${id}`,
  launchpadUpcoming: "upcoming-launchpad-listing",
  launchpadLive: "live-launchpad-listing",
  launchpadEnded: "ended-launchpad-listing",
  launchpadCancelled: "cancelled-launchpad-listing",
  launchpadUpdateStatus: "update-launchpad-status",
  launchpadSalesTracking: "launchpad-sales-tracking",
  launchpadSummary: "all-launchpads-summary",
};
